<template>
  <div>
    <v-btn v-if="params.data?.montos" class="mb-2" x-small outlined @click="abrirModal">
      {{ montoTotalPagado }}

      <span v-if="tieneAlgunPagoRegularizado || tieneAlgunPagoCompensado" class="red--text font-weight-bold"> * </span>

      <v-icon small>mdi-information-outline</v-icon>
    </v-btn>

    <span v-else>-</span>

    <ModalDetallesMontos ref="modalDetallesMontosRef" :montos="params.data?.montos" />
  </div>
</template>

<script>
import { formatearValorAMoneda } from '../utils/funciones';
import botonMontoTotalConceptosMixin from './../mixins/boton-monto-total-conceptos.mixin';

export default {
  name: 'BotonMontoTotalConceptos',
  mixins: [botonMontoTotalConceptosMixin],
  computed: {
    tieneAlgunPagoRegularizado() {
      if (!this.params.data?.montos) {
        return false;
      }

      const montos = this.params.data.montos;

      return (
        Number(montos?.regularizadoMatricula) > 0 ||
        Number(montos?.regularizadoColegiatura) > 0 ||
        Number(montos?.regularizadoCertificacion) > 0
      );
    },
    tieneAlgunPagoCompensado() {
      if (!this.params.data?.montos) {
        return false;
      }

      const montos = this.params.data.montos;

      return (
        Number(montos?.compensacionMatricula) > 0 ||
        Number(montos?.compensacionColegiatura) > 0 ||
        Number(montos?.compensacionCertificacion) > 0
      );
    },
    montoTotalPagado() {
      if (!this.params.data?.montos) {
        return '-';
      }

      return formatearValorAMoneda(
        Number(this.params.data?.montos?.pagoMatricula) +
          Number(this.params.data?.montos?.pagoColegiatura) +
          Number(this.params.data?.montos?.pagoCertificacion),
      );
    },
  },
};
</script>
